import * as React from 'react'
import MobilePreviewView from './MobilePreviewView'
import { Box, Typography } from '@material-ui/core'
import PriceToolbar from './PriceToolbar'

type CoursePreviewProps = {
    course: Course
}

const CoursePreview = ({ course }: CoursePreviewProps) => {

    return <MobilePreviewView title="课程详情">
        <Box>
            <Box>
                <img src={course?.cover} style={{ width: '100%', height: '240px', objectFit: 'cover' }} />
            </Box>
            <Box p={2}>
                <Typography>
                    {course?.name}
                </Typography>
            </Box>
            <Box boxSizing="border-box">
                <div className="html-format" dangerouslySetInnerHTML={{ __html: course && course.details ? course.details : '' }}></div>
            </Box>
            {/* <PriceToolbar price={course?.price} /> */}
        </Box>
    </MobilePreviewView>
}

export default CoursePreview